import { VlGapType } from '@/interfaces/server-data';
import { FormatNumber } from '@/numberFormatter';
import { i18n } from '@/services/i18n';

export class Formatter {
  static vlGap(
    value: number | null | undefined,
    type: VlGapType | undefined,
  ): string {
    if (value === null || value === undefined) {
      return '';
    }
    const formatted = FormatNumber.format(value);
    const suffixKey = type === 'RUBLES'
      ? 'masterData.assortment.vlGapTypeRubles'
      : 'masterData.assortment.vlGapTypePercent';
    return `${formatted} ${i18n.t(suffixKey)}`;
  }
}
